import type { LegalDocument } from "./legal.types";

export const AMHARIC_LEGAL_DOCUMENTS: LegalDocument[] = [
  {
    app: "rider",
    kind: "privacy",
    locale: "am",
    title: "የYegna Rider የግላዊነት ፖሊሲ",
    summary:
      "ይህ ፖሊሲ በYegna Rider የጉዞ ወይም የጥቅል መላኪያ አገልግሎት ሲጠይቁ YegnaTaxi የግል ዳታዎን እንዴት እንደሚይዝ ያብራራል።",
    updated: "ነሐሴ 5 ቀን 2018 ዓ.ም.",
    sections: [
      {
        id: "who-we-are",
        heading: "1. ስለ እኛ",
        paragraphs: [
          "YegnaTaxi በAD Technologies and Trading የሚጠቀምበት የንግድ ስም ነው። በዚህ ፖሊሲ የተገለጸውን ዳታ ለምንና እንዴት እንደሚቀናበር AD Technologies and Trading ይወስናል፤ ሌላ አካል በዳታ ስብሰባ ጊዜ ካልተገለጸ በስተቀር የዳታ ተቆጣጣሪ ነው።",
          "የንግድ አድራሻችን፦ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ።",
        ],
      },
      {
        id: "scope",
        heading: "2. የፖሊሲው ወሰን",
        paragraphs: [
          "ይህ ፖሊሲ በYegna Rider የሞባይል መተግበሪያ፣ በተያያዘ የተሳፋሪ ድጋፍ እና በyegnataxi.com ላይ በሚገኙ የተሳፋሪ አገልግሎቶች ላይ ይፈጸማል። የራሱን የግላዊነት ፖሊሲ ባወጣ የሦስተኛ ወገን አገልግሎት ላይ አይፈጸምም።",
          "Yegna Rider ዕድሜያቸው 18 ዓመት እና ከዚያ በላይ ለሆኑ ሰዎች የታሰበ ነው። ዕድሜዎ ከ18 ዓመት በታች ከሆነ መለያ አይክፈቱ።",
        ],
      },
      {
        id: "data-we-collect",
        heading: "3. የምንሰበስበው የግል ዳታ",
        bullets: [
          "የመለያና የማንነት ዳታ፦ ስም፣ የሞባይል ቁጥር፣ እንደ ምርጫ ኢሜይል፣ የመለያ ሚና፣ የማረጋገጫ ሁኔታ እና የመግቢያ ክፍለ ጊዜ መዝገቦች።",
          "የጉዞና መላኪያ ዳታ፦ መነሻ፣ መድረሻ፣ መንገድ፣ የአገልግሎት ዓይነት፣ ቀጠሮ፣ የጥቅል ተቀባይ መረጃ፣ የተመደበ አሽከርካሪ፣ ሁኔታ፣ ዋጋ፣ ስረዛ፣ ደረጃ እና ታሪክ።",
          "የመገኛ ቦታ ዳታ፦ ፈቃድ ሲሰጡ ትክክለኛ የመሣሪያ መገኛ፣ የፈለጉት ወይም የመረጡት ቦታ እና ጉዞን ለማዘጋጀት፣ ለመከታተል፣ ለደህንነት ወይም ለድጋፍ የሚያስፈልግ መገኛ።",
          "የክፍያና ክሬዲት ዳታ፦ የዋጋና ክሬዲት መጠን፣ የግብይት ማጣቀሻ፣ ተመላሽ ክፍያ፣ ማስተካከያ እና የክፍያ ሁኔታ። የክፍያ አቅራቢው የክፍያ መሣሪያ መረጃን በራሱ ፖሊሲ መሠረት በቀጥታ ሊሰበስብ ይችላል።",
          "የግንኙነትና ድጋፍ ዳታ፦ የድጋፍ ጥያቄ፣ አስተያየት፣ ደረጃ፣ በፈቃድዎ የሚያቀርቡት የሪፈራል መረጃ እና ቅሬታ ወይም የደህንነት ክስተት ለማጣራት የሚያስፈልግ መዝገብ።",
          "የመሣሪያ፣ ኔትወርክና ደህንነት ዳታ፦ የመተግበሪያ ስሪት፣ የመሣሪያና ስርዓተ ክወና ዓይነት፣ ቋንቋ፣ የማሳወቂያ ቶከን፣ IP አድራሻ፣ የጥያቄ መለያ፣ ሰዓት፣ የስህተት መረጃ እና የማጭበርበር ምልክቶች።",
          "የድረ ገጹ አስተናጋጅና የደህንነት ስርዓቶች የሚፈጥሯቸው ቴክኒካዊ መዝገቦች። ድረ ገጹ በአሁኑ ጊዜ የማስታወቂያ ኩኪዎችን ወይም የሦስተኛ ወገን የማስታወቂያ መከታተያዎችን አይጠቀምም።",
        ],
      },
      {
        id: "how-we-use-data",
        heading: "4. ዳታውን ለምንና እንዴት እንጠቀማለን",
        bullets: [
          "መለያዎን ለመፍጠርና ለመጠበቅ፣ የሞባይል ቁጥርዎን ለማረጋገጥ እና የመግቢያ ክፍለ ጊዜዎን ለማስተዳደር።",
          "መንገድና ዋጋ ለመገመት፣ ብቁ አሽከርካሪ ለማገናኘት፣ ጉዞውን ለማስተዳደርና ለመከታተል።",
          "ለጥቅል መላኪያ አስፈላጊውን የተቀባይና የመላኪያ መረጃ ለተመደበው አሽከርካሪ ለማቅረብ።",
          "ድጋፍ ለመስጠት፣ ክርክር ለመፍታት፣ ተመላሽ ክፍያ ወይም ማስተካከያ ለማድረግ እና የደህንነት ጉዳይ ለመመርመር።",
          "ስለ ማረጋገጫ፣ ቦታ ማስያዝ፣ የአሽከርካሪ መድረስ፣ የጉዞ ሁኔታ፣ ደህንነትና የመለያ ለውጥ አስፈላጊ መልዕክቶችን ለመላክ።",
          "ማጭበርበርን፣ አላግባብ መጠቀምን፣ አደገኛ ድርጊትንና ያልተፈቀደ መግቢያን ለመከላከል እና ውሎቻችንን ለማስፈጸም።",
          "የኢትዮጵያ ሕግን፣ ሕጋዊ የመንግሥት ጥያቄን፣ የሂሳብና የቁጥጥር ግዴታን ለማክበር።",
          "በተጠቃለለ ወይም ተገቢ ጥበቃ ባለው መረጃ አማካይነት የአገልግሎቱን ጥራት ለማሻሻል።",
        ],
        paragraphs: [
          "ዳታን የምናቀናብረው አገልግሎቱን ለመስጠትና ከእርስዎ ጋር ያለንን ውል ለመፈጸም፣ ሕግን ለማክበር፣ ሕጋዊ ጥቅምና ደህንነትን ለመጠበቅ፣ ወይም ፈቃድ በሚያስፈልግበት ጊዜ በእርስዎ ፈቃድ ነው። ፈቃድዎን ለወደፊት ማንሳት ይችላሉ፤ ይህ ግን ከዚያ በፊት በሕጋዊነት የተደረገውን አይሽርም እና አንዳንድ ባህሪያትን ሊያስቆም ይችላል።",
        ],
      },
      {
        id: "location",
        heading: "5. የመገኛ ቦታ ዳታ",
        paragraphs: [
          "መገኛ ቦታ ጉዞ ወይም መላኪያ ለመጠየቅና ለማጠናቀቅ ዋና ነገር ነው። በሰጡት ፈቃድና በንቁ ጉዞዎ መሠረት Yegna Rider መነሻ ለመጠቆም፣ መንገድ ለመገመት፣ በአቅራቢያ ያሉ ብቁ አሽከርካሪዎችን ለማግኘት፣ የጉዞ ሂደትን ለማሳየትና የደህንነት ጉዳይን ለመደገፍ መገኛዎን ሊጠቀም ይችላል።",
          "የመገኛ ፈቃድን በመሣሪያዎ ቅንብር መቆጣጠር ይችላሉ። ሲያጠፉት አድራሻን በእጅ ማስገባት ሊያስፈልግ ወይም በመገኛ ላይ የተመሠረቱ ባህሪያት ሊቋረጡ ይችላሉ። ትክክለኛ የመገኛ ዳታን አንሸጥም።",
        ],
      },
      {
        id: "sharing",
        heading: "6. ዳታ የምናጋራበት ጊዜ",
        bullets: [
          "ብቁ ወይም የተመደበ አሽከርካሪ በጉዞው ደረጃና በደህንነት ቁጥጥር መሠረት ለአገልግሎቱ ብቻ የሚያስፈልገውን የተሳፋሪ፣ መነሻ፣ መድረሻ፣ ተቀባይና መገናኛ መረጃ ያገኛል።",
          "የቴክኖሎጂ አቅራቢዎች ለማስተናገድ፣ ማከማቸት፣ ካርታና መንገድ፣ የሞባይል ማረጋገጫ፣ ማሳወቂያ፣ ግንኙነት፣ ክፍያ፣ ደህንነትና ድጋፍ በውልና በምስጢራዊነት ቁጥጥር ሥር ዳታን ሊያቀናብሩ ይችላሉ።",
          "ሥልጣን ያላቸው የYegnaTaxi ሠራተኞች ለሥራ፣ ድጋፍ፣ ደህንነት፣ ፋይናንስ፣ ሕግ ተገዢነት ወይም ቴክኒክ ደህንነት እንደ ሚናቸው ዳታን ሊያዩ ይችላሉ።",
          "ሕግ ሲጠይቅ ወይም መብትን፣ ደህንነትንና ሕጋዊ ጥያቄን ለመጠበቅ ዳታ ለፍርድ ቤት፣ ተቆጣጣሪ፣ ሕግ አስከባሪ፣ አማካሪ ወይም ኢንሹራንስ ሰጪ ሊሰጥ ይችላል።",
          "በውህደት፣ በፋይናንስ፣ በድርጅት ለውጥ ወይም በሽያጭ ጊዜ በሕጋዊ ጥበቃ ሥር ዳታ ሊተላለፍ ይችላል።",
        ],
        paragraphs: ["የግል ዳታን አንሸጥም። አሽከርካሪዎችና አቅራቢዎች የተሳፋሪ ዳታን ለሌላ ግላዊ ወይም የገበያ ዓላማ መጠቀም አይችሉም።"],
      },
      {
        id: "transfers",
        heading: "7. ውጭ አገር ማከማቸትና ማስተላለፍ",
        paragraphs: [
          "አንዳንድ የቴክኖሎጂ አቅራቢዎች ዳታን ከኢትዮጵያ ውጭ ሊያከማቹ ወይም ሊያቀናብሩ ይችላሉ። ከድንበር ተሻጋሪ ዝውውር በፊት የመድረሻውንና የአቅራቢውን ሁኔታ እንመረምራለን፤ በኢትዮጵያ ሕግ የሚፈለገውን ሕጋዊ መሠረት፣ ፈቃድ፣ ውልና የደህንነት ጥበቃ እንጠቀማለን። ሕግ በኢትዮጵያ እንዲቆይ የሚጠይቀው የዳታ ዓይነት በኢትዮጵያ ይቆያል።",
        ],
      },
      {
        id: "retention",
        heading: "8. ዳታን የምናቆይበት ጊዜ",
        paragraphs: [
          "የግል ዳታን በዚህ ፖሊሲ ለተገለጸው ዓላማ እስካስፈለገ ድረስ ብቻ እናቆያለን። ጊዜው መለያዎ ንቁ መሆኑን፣ ጉዞ፣ መላኪያ፣ ክፍያ፣ ቅሬታ ወይም ክርክር ክፍት መሆኑን እና ለግብር፣ ሂሳብ፣ ትራንስፖርት፣ ቁጥጥርና ሕጋዊ መዝገብ የሚያስፈልገውን ጊዜ ይከተላል።",
          "ዳታው ካላስፈለገ እናጠፋዋለን፣ ማንነት አልባ እናደርገዋለን ወይም እስኪጠፋ ድረስ በደህና እንለየዋለን። በሕግ፣ ባልተፈታ ክርክር፣ በደህንነት ወይም በማጭበርበር ምርመራ ምክንያት ማቆየት ያለብንን መዝገብ የማጥፋት ጥያቄ ላያስወግድ ይችላል።",
        ],
      },
      {
        id: "security",
        heading: "9. ደህንነት",
        paragraphs: [
          "ከስጋቱ ጋር የሚመጣጠኑ ቴክኒካዊና ድርጅታዊ ጥበቃዎችን እንጠቀማለን፤ እነዚህም የመዳረሻ ቁጥጥር፣ የተጠበቀ ግንኙነት፣ የማንነት ማረጋገጫ፣ መዝገብና የሠራተኛ መዳረሻ ገደብን ያካትታሉ። ማንኛውም ስርዓት ሙሉ በሙሉ ደህና ነው ሊባል አይችልም። የማረጋገጫ ኮድና የይለፍ ቃልዎን ይጠብቁ፤ ያልተፈቀደ መግቢያ ከጠረጠሩ ወዲያውኑ ያሳውቁን።",
        ],
      },
      {
        id: "rights",
        heading: "10. የዳታ ጥበቃ መብቶችዎ",
        paragraphs: [
          "በግል ዳታ ጥበቃ አዋጅ ቁጥር 1321/2016 እና በሚመለከተው ገደብ መሠረት ስለ ማቀናበሩ መረጃ ማግኘት፣ ዳታዎን መድረስ፣ የተሳሳተውን ማስተካከል፣ እንዲጠፋ መጠየቅ፣ አንዳንድ ማቀናበርን መገደብ ወይም መቃወም፣ ሲፈጸም ዳታን ተንቀሳቃሽ ቅርጽ ማግኘት፣ ፈቃድን ማንሳት እና ከፍተኛ ተጽዕኖ ያለውን ሙሉ በሙሉ አውቶማቲክ ውሳኔ መቃወም ይችላሉ።",
          "ጥያቄን በመተግበሪያው ድጋፍ ወይም በንግድ አድራሻችን ያቅርቡ። ከመፈጸማችን በፊት ማንነትዎን ልናረጋግጥ እንችላለን። ለግል ዳታ ጥበቃ ባለሥልጣን ለሆነው የኢትዮጵያ ኮሙኒኬሽን ባለሥልጣንም ቅሬታ ማቅረብ ይችላሉ። መረጃ pdp.eca.et ላይ ይገኛል።",
        ],
      },
      {
        id: "choices",
        heading: "11. ምርጫዎችዎ",
        bullets: [
          "የማሳወቂያና የመገኛ ፈቃድን በመሣሪያዎ ቅንብር ይቀይሩ።",
          "በመተግበሪያው የሚቻለውን የመገለጫ መረጃ ያስተካክሉ ወይም ድጋፍን ይጠይቁ።",
          "እንደ ምርጫ ኢሜይል፣ ሪፈራል፣ አስተያየትና ደረጃ መስጠትን ይምረጡ።",
          "በሕግ ማቆየት ካለብን መዝገብ በስተቀር መለያዎ እንዲዘጋ ይጠይቁ።",
        ],
      },
      {
        id: "changes-contact",
        heading: "12. ለውጦችና መገናኛ",
        paragraphs: [
          "አገልግሎቱ፣ አቅራቢዎቹ ወይም ሕጉ ሲለወጥ ፖሊሲውን ልናሻሽል እንችላለን። አዲሱን ቀን እናወጣለን፤ ለውጡ በመብትዎ ወይም በዳታ አጠቃቀማችን ላይ ከፍተኛ ተጽዕኖ ሲኖረው በመተግበሪያው ተጨማሪ ማሳወቂያ እንሰጣለን።",
          "ለግላዊነት ጥያቄ የYegna Rider ድጋፍን ይጠቀሙ ወይም ለAD Technologies and Trading (YegnaTaxi)፣ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ ይጻፉ።",
        ],
      },
    ],
  },
  {
    app: "driver",
    kind: "privacy",
    locale: "am",
    title: "የYegna Driver የግላዊነት ፖሊሲ",
    summary:
      "ይህ ፖሊሲ ለማሽከርከር ሲያመለክቱ፣ መስመር ላይ ሲገቡ፣ ጥያቄ ሲቀበሉ እና ጉዞ ወይም መላኪያ ሲያጠናቅቁ YegnaTaxi የግል ዳታዎን እንዴት እንደሚይዝ ያብራራል።",
    updated: "ነሐሴ 5 ቀን 2018 ዓ.ም.",
    sections: [
      {
        id: "who-we-are",
        heading: "1. ስለ እኛ",
        paragraphs: [
          "YegnaTaxi በAD Technologies and Trading የሚጠቀምበት የንግድ ስም ነው። AD Technologies and Trading በዚህ ፖሊሲ የተገለጸውን የግል ዳታ ለምንና እንዴት እንደሚቀናበር የሚወስን የዳታ ተቆጣጣሪ ነው።",
          "የንግድ አድራሻችን፦ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ።",
        ],
      },
      {
        id: "scope",
        heading: "2. የፖሊሲው ወሰን",
        paragraphs: [
          "ይህ ፖሊሲ በYegna Driver መተግበሪያ፣ በአሽከርካሪ ማመልከቻና ግምገማ፣ በድጋፍ እና በyegnataxi.com ላይ በሚገኙ የአሽከርካሪ አገልግሎቶች ላይ ይፈጸማል። ማመልከቻዎ በመጠባበቅ፣ በመፈቀድ፣ ባለመፈቀድ፣ በመታገድ ወይም በመዘጋት ሁኔታ ላይ ቢሆንም ይሠራል።",
          "ዕድሜዎ 18 ዓመት ወይም ከዚያ በላይ መሆንና በኢትዮጵያ ለመንዳትና ለተመረጠው አገልግሎት በሕግ ብቁ መሆን አለብዎት።",
        ],
      },
      {
        id: "data-we-collect",
        heading: "3. የምንሰበስበው የግል ዳታ",
        bullets: [
          "የመለያ ዳታ፦ ስም፣ ሞባይል፣ እንደ ምርጫ ኢሜይል፣ የማረጋገጫ ሁኔታ፣ የመለያ ሚና፣ ቋንቋ፣ የመግቢያ ክስተትና ክፍለ ጊዜ።",
          "የማመልከቻና የማንነት ዳታ፦ የመገለጫ ፎቶ፣ የማመልከቻ መልሶች፣ የግምገማ ሁኔታና ማስታወሻ፣ የመንጃ ፈቃድ፣ የማንነትና የተገዢነት ሰነዶች፣ የሰነድ ቁጥርና የሚያበቃበት ቀን።",
          "የተሽከርካሪ ዳታ፦ የባለቤትነት ወይም ፈቃድ መረጃ፣ ሰሌዳ፣ ምዝገባ፣ አምራች፣ ሞዴል፣ ዓይነት፣ ቀለም፣ አቅም፣ የምርመራና ኢንሹራንስ መዝገብ እና የውስጥና የውጭ ፎቶዎች።",
          "የመገኛና የዝግጁነት ዳታ፦ ትክክለኛ የመሣሪያ መገኛ፣ ሰዓት፣ መሣሪያው የሚሰጠው አቅጣጫ ወይም እንቅስቃሴ፣ የመስመር ላይ ሁኔታ፣ የአገልግሎት ምርጫ፣ የሥራ ራዲየስ እና መገኛው ምን ያህል ወቅታዊ መሆኑ።",
          "የሥራና ጉዞ ዳታ፦ የተላኩ፣ የተቀበሉ፣ የተቃወሙ፣ ያለፉ ወይም የተሰረዙ ጥያቄዎች፣ መነሻና መድረሻ፣ ለጉዞው የሚያስፈልግ የተሳፋሪ ወይም ተቀባይ መረጃ፣ መንገድ፣ ሁኔታ፣ ቅሬታ፣ ደረጃና ታሪክ።",
          "የፋይናንስ ዳታ፦ ዋጋ፣ ኮሚሽን፣ ክሬዲት፣ የሒሳብ መዝገብ፣ ማስተካከያ፣ ማበረታቻ፣ ተመላሽ ክፍያ፣ የክፍያ ሁኔታና ማጣቀሻ።",
          "የግንኙነት፣ የድጋፍ፣ የመሣሪያ፣ የኔትወርክና የደህንነት ዳታ፤ ይህም ትኬት፣ መልዕክት፣ ቅሬታ፣ የመተግበሪያ ስሪት፣ የመሣሪያ ዓይነት፣ የማሳወቂያ ቶከን፣ IP አድራሻ፣ የስህተት ክስተትና የማጭበርበር ምልክትን ያካትታል።",
          "የድረ ገጹ አስተናጋጅና የደህንነት ስርዓቶች የሚፈጥሯቸው ቴክኒካዊ መዝገቦች። ድረ ገጹ በአሁኑ ጊዜ የማስታወቂያ ኩኪዎችን ወይም የሦስተኛ ወገን የማስታወቂያ መከታተያዎችን አይጠቀምም።",
        ],
      },
      {
        id: "how-we-use-data",
        heading: "4. ዳታውን ለምንና እንዴት እንጠቀማለን",
        bullets: [
          "መለያን ለመፍጠርና ለመጠበቅ፣ የሞባይል ቁጥርን ለማረጋገጥ።",
          "የአሽከርካሪ ማመልከቻ፣ ሰነድና ተሽከርካሪ ለመገምገም፣ ወቅታዊ ብቃትን ለመወሰንና እድሳትን ለማስተዳደር።",
          "ተስማሚ የጉዞ ጥያቄ ለማሳየት፣ ምደባና መንገድን ለመደገፍ፣ የጉዞ ሂደትን ለመከታተል እና ከተሳፋሪ ወይም ተቀባይ ጋር ግንኙነትን ለማስቻል።",
          "ዋጋ፣ ክሬዲት፣ ኮሚሽን፣ ማበረታቻ፣ ተመላሽ ክፍያና ማስተካከያ ለማስላት እና ሊመረመር የሚችል የፋይናንስ መዝገብ ለመያዝ።",
          "ደህንነትን፣ የአገልግሎት ጥራትን፣ ማጭበርበርን፣ የመገኛ ትክክለኛነትንና ሕግ ተገዢነትን ለመቆጣጠር።",
          "ድጋፍ ለመስጠት፣ ቅሬታና ክስተት ለመመርመር፣ ክርክር ለመፍታት።",
          "ስለ ጥያቄ፣ ጉዞ፣ ሰነድ ግምገማ፣ ክሬዲት፣ ደህንነትና መለያ ሁኔታ አስፈላጊ ማሳወቂያ ለመላክ።",
          "የኢትዮጵያ ሕግን፣ ሕጋዊ ጥያቄን፣ የሂሳብና የቁጥጥር ግዴታን ለማክበር እና የአገልግሎት ጥራትን ለማሻሻል።",
        ],
        paragraphs: [
          "ዳታን የምናቀናብረው በማመልከቻዎ ላይ እርምጃ ለመውሰድ፣ ውላችንን ለመፈጸም፣ ሕግን ለማክበር፣ ሕጋዊ ጥቅምና ደህንነትን ለመጠበቅ ወይም ፈቃድ ሲያስፈልግ በፈቃድዎ ነው። አስፈላጊ ዳታ ላይ ፈቃድን ማንሳት አንድን ባህሪ ወይም የአሽከርካሪነት ተሳትፎን ሊያስቆም ይችላል።",
        ],
      },
      {
        id: "location",
        heading: "5. መገኛና የሥራ ዝግጁነት",
        paragraphs: [
          "Yegna Driver መስመር ላይ ሲሆኑ የምደባ ብቃትን ለመወሰን፣ ለተሳፋሪዎች አጠቃላይ ዝግጁነትዎን በግላዊነት በተጠበቀ መልኩ ለማሳየት፣ በአቅራቢያ ያለ ጥያቄ ለመላክ፣ መነሻና መንገድን ለመደገፍ፣ ከተመደቡ በኋላ የጉዞ ሂደትን ለተሳፋሪው ለማሳየትና ለደህንነት ድጋፍ ትክክለኛ መገኛዎን ይጠቀማል። በመሣሪያዎ ፈቃድ መሠረት ንቁ ጉዞ ሲኖር መተግበሪያው ከበስተጀርባ ሆኖም መገኛን ሊጠቀም ይችላል።",
          "ለመሥራት ዝግጁ ካልሆኑ ከመስመር ውጭ ይሁኑ። የመገኛ ፈቃድን መቆጣጠር ይችላሉ፤ አስፈላጊ ፈቃዱን ማጥፋት ግን መስመር ላይ መግባትን ወይም ጉዞን ማጠናቀቅን ያስቆማል። ትክክለኛ የመገኛ ዳታን አንሸጥም።",
        ],
      },
      {
        id: "sharing",
        heading: "6. ዳታ የምናጋራበት ጊዜ",
        bullets: [
          "ተሳፋሪዎች ለመተማመንና ለደህንነት የሚያስፈልገውን ስም፣ የመገለጫ ፎቶ፣ የተሽከርካሪ መግለጫና ሰሌዳ እንዲሁም ከምደባ በኋላ የንቁ ጉዞ መገኛን ያገኛሉ። የግል ማመልከቻና የተገዢነት ሰነዶች ለተሳፋሪ አይጋሩም።",
          "የቴክኖሎጂ አቅራቢዎች ለማስተናገድ፣ የግል ሰነድ ማከማቻ፣ ካርታ፣ ማረጋገጫ፣ ማሳወቂያ፣ ክፍያ፣ ደህንነትና ድጋፍ በውልና በምስጢራዊነት ቁጥጥር ሥር ዳታን ሊያቀናብሩ ይችላሉ።",
          "ሥልጣን ያላቸው የYegnaTaxi ሠራተኞች ለግምገማ፣ ምደባ፣ ድጋፍ፣ ደህንነት፣ ፋይናንስ፣ ሕግ ተገዢነት ወይም ቴክኒክ ደህንነት እንደ ሚናቸው ዳታን ሊያዩ ይችላሉ።",
          "ሕግ ሲጠይቅ ወይም መብትን፣ ደህንነትንና ሕጋዊ ጥያቄን ለመጠበቅ ዳታ ለፍርድ ቤት፣ ተቆጣጣሪ፣ ሕግ አስከባሪ፣ አማካሪ ወይም ኢንሹራንስ ሰጪ ሊሰጥ ይችላል።",
          "በውህደት፣ በፋይናንስ፣ በድርጅት ለውጥ ወይም በሽያጭ ጊዜ በሕጋዊ ጥበቃ ሥር ዳታ ሊተላለፍ ይችላል።",
        ],
        paragraphs: ["የግል ዳታን አንሸጥም። ተሳፋሪዎችና አቅራቢዎች የአሽከርካሪ ዳታን ለሌላ ግላዊ ወይም የገበያ ዓላማ መጠቀም አይችሉም።"],
      },
      {
        id: "transfers",
        heading: "7. ውጭ አገር ማከማቸትና ማስተላለፍ",
        paragraphs: [
          "አንዳንድ የቴክኖሎጂ አቅራቢዎች ዳታን ከኢትዮጵያ ውጭ ሊያከማቹ ወይም ሊያቀናብሩ ይችላሉ። ከዝውውር በፊት አቅራቢውንና መድረሻውን እንመረምራለን፤ በኢትዮጵያ ሕግ የሚፈለገውን ሕጋዊ መሠረት፣ ፈቃድ፣ ውልና ጥበቃ እንጠቀማለን። በሕግ በኢትዮጵያ እንዲቆይ የሚጠየቅ ዳታ በኢትዮጵያ ይቆያል።",
        ],
      },
      {
        id: "retention",
        heading: "8. ዳታን የምናቆይበት ጊዜ",
        paragraphs: [
          "የማመልከቻና የሥራ ዳታን ለግምገማ፣ ንቁ ተሳትፎ፣ እድሳት፣ ደህንነት፣ ማጭበርበር መከላከል፣ ፋይናንስ፣ ድጋፍና ሕጋዊ ግዴታ እስካስፈለገ ድረስ ብቻ እናቆያለን። ጊዜው የሰነድ ብቃት፣ የመለያ ሁኔታ፣ ያልተፈታ ጉዞ ወይም ክርክር እና የግብር፣ ሂሳብ፣ ትራንስፖርት፣ ኢንሹራንስና የሕግ ጊዜን ይከተላል።",
          "ዳታው ካላስፈለገ እናጠፋዋለን፣ ማንነት አልባ እናደርገዋለን ወይም በደህና እንለየዋለን። ተሳፋሪን ለመጠበቅ፣ ተደጋጋሚ ማጭበርበርን ለመከላከል፣ ሕጋዊ ጥያቄን ለመመለስ ወይም ሕግን ለማክበር የተገደበ መዝገብ ልናቆይ እንችላለን።",
        ],
      },
      {
        id: "security",
        heading: "9. ደህንነት",
        paragraphs: [
          "ለአሽከርካሪና ለሰነድ ዳታ ተገቢ የሆነ ጥበቃ እንጠቀማለን፤ ይህም በሚና ላይ የተመሠረተ መዳረሻ፣ የግል ማከማቻ፣ ለአጭር ጊዜ የተፈቀደ የሰነድ መዳረሻ፣ የተጠበቀ ግንኙነት፣ ማረጋገጫና መዝገብን ያካትታል። ማንኛውም ስርዓት ሙሉ በሙሉ ደህና አይደለም። የይለፍ ቃል፣ ኮድ፣ መሣሪያና ሰነድዎን ይጠብቁ፤ ያልተፈቀደ መዳረሻን ወዲያውኑ ያሳውቁ።",
        ],
      },
      {
        id: "rights",
        heading: "10. የዳታ ጥበቃ መብቶችዎ",
        paragraphs: [
          "በግል ዳታ ጥበቃ አዋጅ ቁጥር 1321/2016 እና በሚመለከተው ገደብ መሠረት ስለ ማቀናበሩ መረጃ ማግኘት፣ ዳታን መድረስ፣ ማስተካከል፣ እንዲጠፋ መጠየቅ፣ ማቀናበርን መገደብ ወይም መቃወም፣ ሲፈጸም ተንቀሳቃሽ ቅርጽ ማግኘት፣ ፈቃድን ማንሳትና ከፍተኛ ተጽዕኖ ያለውን ሙሉ አውቶማቲክ ውሳኔ መቃወም ይችላሉ።",
          "ጥያቄን በDriver ድጋፍ ወይም በአድራሻችን ያቅርቡ። ማንነትዎን ልናረጋግጥ እንችላለን። የብቃት፣ ማንነት፣ ተሽከርካሪ ወይም መገኛ መዝገብን ማጥፋት እንደ አሽከርካሪ መቀጠልዎን ሊያስቆም ይችላል። ለኢትዮጵያ ኮሙኒኬሽን ባለሥልጣንም ቅሬታ ማቅረብ ይችላሉ፤ መረጃ pdp.eca.et ላይ ይገኛል።",
        ],
      },
      {
        id: "choices",
        heading: "11. ምርጫዎችና ኃላፊነቶች",
        bullets: [
          "ጥያቄ መቀበል ወይም ወቅታዊ ዝግጁነትን ማሳየት ካልፈለጉ ከመስመር ውጭ ይሁኑ።",
          "እንደ ምርጫ ያሉ ማሳወቂያዎችንና የመሣሪያ ፈቃዶችን ያስተዳድሩ፤ አስፈላጊ መገኛና የሥራ ማሳወቂያ ለDriver ባህሪያት እንደሚያስፈልጉ ይገንዘቡ።",
          "መገለጫ፣ ተሽከርካሪ፣ ፈቃድ፣ ኢንሹራንስ፣ ምርመራና ሌሎች ሰነዶችን ትክክለኛና ወቅታዊ ያድርጉ።",
          "መረጃን ለማስተካከል ወይም መለያን ለመዝጋት ድጋፍን ይጠይቁ፤ በሕግ የምናቆየው መዝገብ ግን ይቀራል።",
        ],
      },
      {
        id: "changes-contact",
        heading: "12. ለውጦችና መገናኛ",
        paragraphs: [
          "አገልግሎቱ፣ አቅራቢዎቹ ወይም ሕጉ ሲለወጥ ፖሊሲውን ልናሻሽል እንችላለን። አዲሱን ቀን እናወጣለን፤ ከፍተኛ ለውጥ ሲኖር በመተግበሪያው ተጨማሪ ማሳወቂያ እንሰጣለን።",
          "ለግላዊነት ጥያቄ የYegna Driver ድጋፍን ይጠቀሙ ወይም ለAD Technologies and Trading (YegnaTaxi)፣ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ ይጻፉ።",
        ],
      },
    ],
  },
  {
    app: "rider",
    kind: "terms",
    locale: "am",
    title: "የYegna Rider ውሎች እና ሁኔታዎች",
    summary:
      "እነዚህ ውሎች በኢትዮጵያ ውስጥ በYegna Rider ጉዞ፣ የጥቅል መላኪያና ተያያዥ ድጋፍ ሲጠይቁ ይፈጸማሉ።",
    updated: "ነሐሴ 5 ቀን 2018 ዓ.ም.",
    sections: [
      {
        id: "agreement",
        heading: "1. ስምምነትና አቅራቢ",
        paragraphs: [
          "እነዚህ ውሎች በእርስዎና YegnaTaxi በሚል የንግድ ስም በሚሠራው AD Technologies and Trading መካከል ስምምነት ይፈጥራሉ። መለያ በመክፈት ወይም Yegna Riderን በመጠቀም እነዚህን ውሎችና የYegna Rider የግላዊነት ፖሊሲን ይቀበላሉ።",
          "ካልተስማሙ መተግበሪያውን አይጠቀሙ። ለአንዳንድ አገልግሎቶች በግልጽ የሚታዩ ተጨማሪ የዋጋ፣ የማስተዋወቂያ፣ የደህንነት ወይም የአገልግሎት ደንቦች ሊኖሩ ይችላሉ።",
        ],
      },
      {
        id: "eligibility",
        heading: "2. ብቃትና መለያ",
        bullets: [
          "ዕድሜዎ 18 ዓመት ወይም ከዚያ በላይ እና በኢትዮጵያ ስምምነት ለመፈጸም በሕግ ብቁ መሆን አለብዎት።",
          "ትክክለኛና ወቅታዊ መረጃ ያቅርቡ፤ የሞባይል ቁጥርና የመለያ መረጃዎን ያስተካክሉ።",
          "የይለፍ ቃልና የማረጋገጫ ኮድዎን በምስጢር ይያዙ። ያልተፈቀደ አጠቃቀምን በፍጥነት ካላሳወቁ በመለያዎ ለሚደረግ እንቅስቃሴ ኃላፊ ነዎት።",
          "የራስዎን መለያ ብቻ ይጠቀሙ። መለያን መሸጥ፣ ማስተላለፍ፣ ማበደር ወይም ገደብን ለማለፍ አዲስ መለያ መፍጠር አይፈቀድም።",
        ],
      },
      {
        id: "platform",
        heading: "3. Yegna Rider የሚያቀርበው",
        paragraphs: [
          "Yegna Rider ጉዞ ወይም መላኪያ እንዲጠይቁ፣ የመንገድና የዋጋ ግምት እንዲያገኙ፣ ከብቁ አሽከርካሪ ጋር እንዲገናኙ፣ የጉዞ ሁኔታን እንዲከታተሉና ድጋፍ እንዲያገኙ ያስችላል። መገኘቱ በቦታ፣ በጊዜ፣ በኔትወርክ፣ በአሽከርካሪ ብዛት፣ በደህንነትና በሥራ ገደብ ይወሰናል።",
          "ግምት የመድረሻ ጊዜ፣ መንገድ፣ የአሽከርካሪ መገኘት ወይም የመጨረሻ ዋጋ ዋስትና አይደለም። ትራፊክ፣ የመንገድ ሁኔታ፣ የአየር ሁኔታ፣ መዘጋት፣ የኔትወርክ ችግር ወይም ከቁጥጥራችን ውጭ ያለ ክስተት ተጽዕኖ ሊያደርግ ይችላል።",
        ],
      },
      {
        id: "requests",
        heading: "4. ጥያቄ፣ መነሻና ስረዛ",
        bullets: [
          "ትክክለኛ መነሻ፣ መድረሻ፣ የአገልግሎት ዓይነት፣ ቀጠሮ፣ ተሳፋሪና የጥቅል መረጃ ያስገቡ።",
          "በተስማማው መነሻ ቦታ ዝግጁ ይሁኑ፤ ማብራሪያ ሲያስፈልግ በአክብሮት ይገናኙ።",
          "መተግበሪያው አሽከርካሪ እንደተቀበለ ወይም እንደተመደበ እስካላሳየ ድረስ ጥያቄው አልተረጋገጠም።",
          "እርስዎ ወይም አሽከርካሪው በመተግበሪያው በታየው የስረዛ ደንብ መሠረት መሰረዝ ይችላሉ፤ በቅድሚያ የተገለጸ የስረዛ ወይም የጥበቃ ክፍያ ሊኖር ይችላል።",
          "ለደህንነት፣ ለተጠረጠረ አላግባብ አጠቃቀም፣ ለሥራ ችግር ወይም ከቁጥጥር ውጭ ለሆነ ክስተት YegnaTaxi ጉዞን ሊያዘገይ፣ ሊሰርዝ ወይም ሌላ አሽከርካሪ ሊመድብ ይችላል።",
        ],
      },
      {
        id: "fares",
        heading: "5. ዋጋ፣ ክሬዲትና ክፍያ",
        paragraphs: [
          "በሚቻልበት ጊዜ ከማረጋገጥዎ በፊት የዋጋ ግምት ወይም የዋጋ መረጃ ይታያል። የመጨረሻ ዋጋ በተጓዘው መንገድ፣ ርቀት፣ ጊዜ፣ ጥበቃ፣ የመንገድ ክፍያ፣ የአገልግሎት ዓይነት፣ ሕጋዊ ክፍያ፣ ማስተካከያ ወይም በተገለጸ የስረዛ ደንብ ሊቀየር ይችላል።",
          "ባለው የክፍያ ዘዴ መክፈል አለብዎት፤ ትክክለኛ ክፍያን በማጭበርበር መቀልበስ ወይም ማስቀረት አይፈቀድም። ማስተዋወቂያና ክሬዲት ጥሬ ገንዘብ አይደሉም፣ ጊዜ ሊያበቃባቸው እና የአጠቃቀም ገደብ ሊኖራቸው ይችላል።",
        ],
      },
      {
        id: "conduct",
        heading: "6. ደህንነትና ተቀባይነት ያለው ባህሪ",
        bullets: [
          "አሽከርካሪዎችን፣ ሌሎች ተሳፋሪዎችን፣ ሠራተኞችንና ሕዝብን ያክብሩ። ማስፈራራት፣ መድልዎ፣ ጥቃት፣ የፆታ ትንኮሳና ስድብ ክልክል ናቸው።",
          "አሽከርካሪን ፍጥነት እንዲያበዛ፣ ከአቅም በላይ እንዲጭን፣ የትራፊክ ሕግ እንዲጥስ፣ አደገኛ መንገድ እንዲወስድ ወይም ሕገወጥ እቃ እንዲያጓጉዝ አይጠይቁ።",
          "የደህንነት ቀበቶና ሕጋዊ የአሽከርካሪ መመሪያን ይከተሉ። ለልጆች ወይም ለሌሎች ሰዎች ያዘጋጁት ጉዞ ኃላፊነት የእርስዎ ነው።",
          "ተሽከርካሪን፣ መሣሪያን፣ መለያን ወይም የመድረኩን ስርዓት አያበላሹ፣ አይበክሉ ወይም ያለፈቃድ አይድረሱ።",
          "በድንገተኛ አደጋ ጊዜ ተገቢውን የኢትዮጵያ ድንገተኛ አገልግሎት ወይም የአካባቢ ባለሥልጣን ያነጋግሩ። Yegna Rider የድንገተኛ ምላሽ አገልግሎት አይደለም።",
        ],
      },
      {
        id: "deliveries",
        heading: "7. የጥቅል መላኪያ",
        paragraphs: [
          "ጥቅሉን በትክክል መግለጽ፣ የጥቅሉ ሕጋዊ ባለቤት ወይም የመላክ ፈቃድ ያለዎት መሆን፣ በደህና ማሸግ፣ ትክክለኛ የተቀባይ መረጃ መስጠትና የተጠየቀውን መግለጫ ማቅረብ ኃላፊነትዎ ነው።",
        ],
        bullets: [
          "ሰው፣ ሕያው እንስሳ፣ መሣሪያ፣ ፈንጂ፣ ሕገወጥ ዕፅ፣ የተሰረቀ ንብረት፣ አደገኛ ወይም የሚፈስ ነገር፣ ጥሬ ገንዘብ ወይም የማይተካ ውድ እቃ፣ ሕገወጥ ይዘት ወይም በኢትዮጵያ ሕግ የተከለከለ ነገር አይላኩ።",
          "የጥቅሉን ዓይነት፣ ክብደት፣ መጠን፣ የመሰበር እድል ወይም ልዩ ስጋት አይደብቁ።",
          "አደገኛ፣ ሕገወጥ፣ በስህተት የተገለጸ ወይም ለአገልግሎቱ የማይስማማ ጥቅልን YegnaTaxi ወይም አሽከርካሪው ሊቃወም ወይም ሊያቆም ይችላል።",
        ],
      },
      {
        id: "communications",
        heading: "8. ግንኙነትና ግላዊነት",
        paragraphs: [
          "ለማረጋገጫ፣ ደህንነት፣ ቦታ ማስያዝ፣ የጉዞ ሂደት፣ ድጋፍና መለያ አስተዳደር አስፈላጊ መልዕክቶችን ለመቀበል ይስማማሉ። የገበያ መልዕክት ካለ በሕግና በመውጫ ምርጫ መሠረት ይላካል።",
          "የግል ዳታዎ አጠቃቀም በYegna Rider የግላዊነት ፖሊሲ ይመራል። ለሕጋዊ ደህንነት ወይም ለእውነተኛ ቅሬታ ካልሆነ በስተቀር የአሽከርካሪ ዳታ፣ ምስል፣ ንግግር ወይም መገኛ አይቅዱ፣ አያሳትሙ ወይም አላግባብ አይጠቀሙ።",
        ],
      },
      {
        id: "suspension",
        heading: "9. እምቢ ማለት፣ ማገድና መለያ መዝጋት",
        paragraphs: [
          "ለደህንነት፣ ለተጠረጠረ ማጭበርበር፣ ላልተከፈለ ክፍያ፣ ሕገወጥ ድርጊት፣ ተደጋጋሚ ስረዛ ወይም አላግባብ አጠቃቀም፣ የውል ጥሰት፣ የሕግ ግዴታ ወይም የመድረክ ደህንነት ሲያስፈልግ YegnaTaxi ጥያቄን ሊከለክል፣ መለያን ሊገድብ፣ ሊያግድ ወይም ሊዘጋ ይችላል። ተገቢና ሕጋዊ ሲሆን ማሳወቂያ ወይም የግምገማ መንገድ እንሰጣለን።",
          "አገልግሎቱን ማቆምና መለያን እንዲዘጋ መጠየቅ ይችላሉ። ክፍያ፣ መዝገብ፣ ክርክር፣ የአእምሮ ንብረት፣ ኃላፊነትና የሚቆይ ዳታ ድንጋጌ እንደ ባህሪው ይቀጥላል።",
        ],
      },
      {
        id: "intellectual-property",
        heading: "10. መተግበሪያና የአእምሮ ንብረት",
        paragraphs: [
          "YegnaTaxi መተግበሪያውን ለታሰበው የተሳፋሪ አገልግሎት ብቻ እንዲጠቀሙ የተገደበ፣ ግላዊ፣ ሊነሳ የሚችል፣ ለሌላ የማይተላለፍ ፈቃድ ይሰጣል። የመተግበሪያ፣ ብራንድ፣ ንድፍ፣ ሶፍትዌርና ይዘት መብት የYegnaTaxi ወይም የፈቃድ ሰጪዎቹ ነው።",
          "ሕግ በግልጽ ካልፈቀደ በስተቀር መቅዳት፣ እንደገና መሸጥ፣ ኮድ መፍታት፣ ዳታ መፋቅ፣ ማስተጓጎል፣ ደህንነትን ማለፍ ወይም ተወዳዳሪ ዳታ ጎታ መፍጠር አይፈቀድም።",
        ],
      },
      {
        id: "responsibility",
        heading: "11. ኃላፊነትና የአገልግሎት ገደብ",
        paragraphs: [
          "እያንዳንዱ ወገን በማጭበርበር፣ ሆን ብሎ በሠራው ጥፋት፣ በቸልተኝነት ወይም በውል ጥሰት ለሚያደርሰው ጉዳት በኢትዮጵያ ሕግ መሠረት ኃላፊ ነው። ሕግ እንዲወገድ የማይፈቅደው መብት ወይም ኃላፊነት በእነዚህ ውሎች አይወገድም።",
          "በሕግ እስከተፈቀደው ድረስ YegnaTaxi ለተዘዋዋሪ ወይም ሊገመት ለማይችል ጉዳት፣ ለማይገኝ አገልግሎት፣ ለጠፋ ዕድል ወይም ከቁጥጥር ውጭ ላለ ክስተት ኃላፊ አይሆንም። አሽከርካሪው ተሽከርካሪውን በሕግና በደህና ለማሽከርከርና የተቀበለውን ጉዞ ለመፈጸም ኃላፊ ነው።",
        ],
      },
      {
        id: "law-disputes",
        heading: "12. የኢትዮጵያ ሕግና ክርክር",
        paragraphs: [
          "እነዚህ ውሎች በኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ ሕጎች ይመራሉ። በመጀመሪያ በመተግበሪያው ድጋፍ ያነጋግሩን እና ጉዳዩን ለመፍታት ምክንያታዊ ጊዜ ይስጡን። ካልተፈታ በኢትዮጵያ ሕግ ያለውን ተቆጣጣሪ፣ ፍርድ ቤት ወይም ሌላ የክርክር ሂደት መጠቀም ይቻላል። ግዴታ በሆነ ሕግ ተቃራኒ ካልሆነ በአዲስ አበባ ሥልጣን ባለው ፍርድ ቤት ሊቀርብ ይችላል።",
        ],
      },
      {
        id: "changes-contact",
        heading: "13. ለውጦችና መገናኛ",
        paragraphs: [
          "ለአገልግሎት፣ ደህንነት፣ ሥራ ወይም ሕግ ለውጥ ውሎቹን ልናሻሽል እንችላለን። አዲሱን ቀን እናወጣለን፤ ከፍተኛ ለውጥ ሲኖር ተጨማሪ ማሳወቂያ እንሰጣለን። ከተፈጻሚነት ቀን በኋላ መጠቀምዎ ማሻሻያውን እንደተቀበሉ ያሳያል።",
          "ጥያቄን በYegna Rider ድጋፍ ያቅርቡ ወይም ለAD Technologies and Trading (YegnaTaxi)፣ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ ይጻፉ።",
        ],
      },
    ],
  },
  {
    app: "driver",
    kind: "terms",
    locale: "am",
    title: "የYegna Driver ውሎች እና ሁኔታዎች",
    summary:
      "እነዚህ ውሎች በኢትዮጵያ ውስጥ በYegna Driver የአሽከርካሪ ማመልከቻ፣ የመድረክ መዳረሻ፣ የጉዞ ጥያቄ፣ ጉዞ፣ መላኪያና ተያያዥ እንቅስቃሴ ላይ ይፈጸማሉ።",
    updated: "ነሐሴ 5 ቀን 2018 ዓ.ም.",
    sections: [
      {
        id: "agreement",
        heading: "1. ስምምነትና አቅራቢ",
        paragraphs: [
          "እነዚህ ውሎች በእርስዎና YegnaTaxi በሚል የንግድ ስም በሚሠራው AD Technologies and Trading መካከል ስምምነት ይፈጥራሉ። በማመልከት፣ የDriver መለያ በመክፈት ወይም Yegna Driverን በመጠቀም እነዚህን ውሎችና የYegna Driver የግላዊነት ፖሊሲን ይቀበላሉ።",
          "የተፈረመ የአሽከርካሪ፣ የፍሊት፣ የክፍያ ወይም የአገልግሎት ውል ተጨማሪ ድንጋጌ ሊያክል ይችላል። በቀጥታ ግጭት ሲኖር በግዴታ ሕግ ካልተከለከለ በስተቀር የተፈረመው ውል ለዚያ ጉዳይ ቅድሚያ ይኖረዋል።",
        ],
      },
      {
        id: "eligibility",
        heading: "2. ብቃትና ፈቃድ",
        bullets: [
          "ዕድሜዎ 18 ዓመት ወይም ከዚያ በላይ፣ ውል ለመፈጸም ብቁ፣ ሕጋዊ የመንጃ ፈቃድ ያለዎት፣ ሲያስፈልግ በጤናና በችሎታ ብቁ እና በኢትዮጵያ ለተመረጠው አገልግሎት ፈቃድ ያለዎት መሆን አለብዎት።",
          "ትክክለኛ የማመልከቻ፣ ማንነት፣ ፈቃድ፣ ተሽከርካሪ፣ ባለቤትነት ወይም የመጠቀም ፈቃድ፣ ኢንሹራንስ፣ ምርመራና ሌላ የሕግ ተገዢነት መረጃ ያቅርቡ።",
          "በሕግ ወይም በመድረኩ ደንብ የሚፈለጉ ፈቃዶችን፣ ኢንሹራንስን፣ ምርመራን፣ የግብር መዝገብንና ሰነዶችን ወቅታዊ ያድርጉ።",
          "የመድረክ ፈቃድ ቋሚ አይደለም። ወቅታዊ ብቃት በሰነድ፣ በአሽከርካሪና ተሽከርካሪ ሁኔታ፣ በሚፈለግ ክሬዲት፣ በአዲስ መገኛ፣ በደህንነትና በሥራ ደንብ ይወሰናል።",
        ],
      },
      {
        id: "account",
        heading: "3. መለያና መሣሪያ",
        paragraphs: [
          "የራስዎን መለያና የተፈቀደውን ተሽከርካሪ ብቻ ይጠቀሙ። የመግቢያ መረጃና የማረጋገጫ ኮድን ይጠብቁ፤ ሌላ ሰው በመለያዎ ጉዞ እንዳይቀበል ወይም እንዳያከናውን ያድርጉ፤ መጥፋትን ወይም ያልተፈቀደ አጠቃቀምን በፍጥነት ያሳውቁ።",
          "ተስማሚና በደህና የተገጠመ ስልክ፣ የሞባይል አገልግሎት፣ ዳታና ኃይል የማቅረብ ኃላፊነት የእርስዎ ነው። በመንዳት ጊዜ ትኩረትን በሚከፋፍል መልኩ መተግበሪያውን አይጠቀሙ፤ ትኩረት የሚፈልግ ነገር ለማድረግ በደህና ያቁሙ።",
        ],
      },
      {
        id: "relationship",
        heading: "4. ተሳትፎና ሕጋዊ ግንኙነት",
        paragraphs: [
          "Yegna Driver ብቁ አሽከርካሪዎች ጥያቄ እንዲቀበሉና አገልግሎት እንዲፈጽሙ ቴክኖሎጂና የሥራ መሣሪያ ይሰጣል። ከYegnaTaxi፣ ከተሳፋሪ፣ ከፍሊት ባለቤትና ከሕዝብ ባለሥልጣን ጋር ያለዎት ሕጋዊ ግንኙነት በኢትዮጵያ ሕግና በተፈረመ ውል ይወሰናል፤ በዚህ ውል ውስጥ ባለ ስያሜ ብቻ አይወሰንም።",
          "የተፈረመ ውል ወይም ግዴታ ያለው ሕግ ሌላ ካላለ በስተቀር፣ የተቀበሉትን ጉዞ በሕግ ማከናወን፣ የሥራ ጊዜዎን፣ የተሽከርካሪ ወጪ፣ ፈቃድ፣ ግብርና ኢንሹራንስን መሸፈን ኃላፊነትዎ ነው።",
        ],
      },
      {
        id: "availability-offers",
        heading: "5. ዝግጁነት፣ መገኛና የጉዞ ጥያቄ",
        bullets: [
          "እርስዎና የተፈቀደው ተሽከርካሪ ዝግጁ፣ ደህናና በሕግ ብቁ ሲሆኑ ብቻ መስመር ላይ ይግቡ። ዝግጁ ካልሆኑ ወዲያውኑ ከመስመር ውጭ ይሁኑ።",
          "መስመር ላይ ሲሆኑ ትክክለኛና ወቅታዊ መገኛ ይስጡ፤ መገኛ፣ ርቀት፣ መንገድ ወይም የመሣሪያ መረጃን አያስመስሉ፣ አይለውጡ፣ አይደብቁ ወይም ድጋሚ አይላኩ።",
          "በመተግበሪያው መቀበል ወይም ምደባ እስካልተረጋገጠ ድረስ ጥያቄው የእርስዎ አይደለም። ጥያቄ ጊዜው ሊያልፍ፣ ሊነሳ ወይም ለሌላ ብቁ አሽከርካሪ ሊቀርብ ይችላል።",
          "ምደባን፣ ዋጋን፣ ማበረታቻን ወይም የተሳፋሪ ምርጫን ለማጭበርበር መለያ፣ መሣሪያ፣ ስረዛ ወይም መገኛን ከሌሎች ጋር አያቀናብሩ።",
          "የጥያቄ መቀበልና መሰረዝ አፈጻጸም ለሥራና ጥራት ሊጠቀም ይችላል፤ የሚታይ ጥያቄ ግን ዝቅተኛ የጉዞ ብዛት፣ ገቢ ወይም የሥራ ጊዜ ዋስትና አይሰጥም።",
        ],
      },
      {
        id: "service-standards",
        heading: "6. የአገልግሎትና ደህንነት መስፈርቶች",
        bullets: [
          "የኢትዮጵያን የትራፊክ፣ የትራንስፖርት፣ የደህንነት፣ የተደራሽነትና የወንጀል ሕግ እና ሕጋዊ መመሪያን ያክብሩ።",
          "በጥንቃቄ ያሽከርክሩ፣ ከአልኮልና አደንዛዥ ነገር ነፃና ንቁ ይሁኑ፣ የተፈቀደና ለመንገድ ብቁ ተሽከርካሪ ይጠቀሙ፣ ከአቅም በላይ አይጫኑ።",
          "ከመጀመርዎ በፊት ትክክለኛውን ተሳፋሪ፣ ተቀባይ፣ መነሻ፣ መድረሻና አገልግሎት ያረጋግጡ። የጉዞ ሁኔታን በእውነት ያስገቡ፤ ያልተጠናቀቀን ጉዞ እንደተጠናቀቀ አያስመዝግቡ።",
          "ተሳፋሪዎችን፣ ተቀባዮችን፣ ሠራተኞችን፣ ሌሎች አሽከርካሪዎችንና ሕዝብን ያክብሩ። መድልዎ፣ ማስፈራራት፣ ጥቃት፣ የፆታ ትንኮሳ፣ በቀልና ስድብ ክልክል ናቸው።",
          "ከጉዞ በኋላ ለጠፋ እቃ፣ ለደህንነት፣ ለድጋፍ ወይም ላልተፈታ የጉዞ ጉዳይ ካልሆነ በስተቀር ተሳፋሪን ወይም ተቀባይን አያነጋግሩ፤ ዳታቸውን አላግባብ አይጠቀሙ።",
          "የስልኩን የመንገድ መተግበሪያ በሕግና በደህና ይጠቀሙ። ካርታ፣ መንገድ፣ ትራፊክ ወይም አድራሻ ሁልጊዜ የተሟላና ስህተት አልባ ነው ተብሎ ዋስትና አይሰጥም።",
        ],
      },
      {
        id: "deliveries",
        heading: "7. የጥቅል መላኪያ",
        paragraphs: [
          "የተቀበሉትን ጥቅል በተገቢው ሁኔታ ይያዙ፣ መውሰድና ማስረከብን እንደታዘዘው ያረጋግጡ፣ ሕግ፣ አስቸኳይ ደህንነት ወይም የተፈቀደ ምርመራ ካልጠየቀ በስተቀር ጥቅልን አይክፈቱ ወይም አይጠቀሙ። አደገኛ፣ ሕገወጥ፣ በስህተት የተገለጸ ወይም የማይስማማ ጥቅልን መቃወምና ድጋፍን ማነጋገር ይችላሉ።",
          "ሰውን እንደ ጥቅል፣ ሕያው እንስሳ፣ መሣሪያ፣ ፈንጂ፣ ሕገወጥ ዕፅ፣ የተሰረቀ ንብረት፣ አደገኛ ወይም የሚፈስ ነገር፣ ሕገወጥ ይዘት ወይም ሌላ የተከለከለ እቃ እያወቁ አያጓጉዙ።",
        ],
      },
      {
        id: "fares",
        heading: "8. ዋጋ፣ ኮሚሽን፣ ክሬዲትና ክፍያ",
        paragraphs: [
          "ዋጋ፣ ኮሚሽን፣ ማበረታቻ፣ ክሬዲት፣ ማስተካከያ፣ የጥሬ ገንዘብ አያያዝ፣ የክፍያ ጊዜና ዝቅተኛ የክሬዲት ደንብ በመተግበሪያው ወይም በተለየ ውል ይታያል። ያልተገለጸ ክፍያ አይጠይቁ፣ መንገድ ወይም የጉዞ ሁኔታን አያጭበርብሩ፣ ያልተገባ ገንዘብ አይያዙ ወይም ሕጋዊ ክፍያን ለማስቀረት ጉዞን ከመድረኩ ውጭ አያድርጉ።",
          "የሒሳብ መዝገብዎን ይመልከቱ፤ እውነተኛ ስህተትን በፍጥነት ያሳውቁ። YegnaTaxi የተደጋገመ፣ የተሳሳተ፣ የተጭበረበረ፣ የተመለሰ ወይም ያልተፈቀደ መዝገብን ከግምገማ በኋላ ሊያስተካክል ይችላል። የተፈረመ ውል ወይም ግዴታ ያለው ሕግ ሌላ ካላለ በስተቀር የራስዎ ግብር፣ ሕጋዊ ክፍያ፣ የሥራ ወጪና ኢንሹራንስ ኃላፊነት የእርስዎ ነው።",
        ],
      },
      {
        id: "documents-review",
        heading: "9. ሰነድ፣ ክትትልና ግምገማ",
        paragraphs: [
          "YegnaTaxi የሚያቀርቡትን መረጃ እንዲመረምርና አስፈላጊና ሕጋዊ ሲሆን ከሰነድ ሰጪ፣ ከባለቤት፣ ከኢንሹራንስ ሰጪ፣ ከተቆጣጣሪ ወይም ከሌላ ሕጋዊ ምንጭ ጋር እንዲያረጋግጥ ይፈቅዳሉ። የተለወጠ፣ የተበደረ፣ ጊዜው ያለፈ፣ የሚያሳስት ወይም ያልተፈቀደ ሰነድ አያቅርቡ።",
          "የደህንነት ሪፖርት፣ ስረዛ፣ ቅሬታ፣ ደረጃ፣ የመገኛ ትክክለኛነት፣ የጉዞ መዝገብ፣ የሰነድ ሁኔታና የማጭበርበር ጥርጣሬን ልንገመግም እንችላለን። ከፍተኛ ውሳኔ የሰው ግምገማ ሊኖረው ይችላል። በተገቢ ምርመራ ይተባበሩ።",
        ],
      },
      {
        id: "suspension",
        heading: "10. እምቢ ማለት፣ ማገድና ማቋረጥ",
        paragraphs: [
          "ሰነድ ጊዜው ሲያልፍ ወይም ውድቅ ሲሆን፣ ብቁ ካልሆኑ፣ የደህንነት ስጋት፣ ከባድ ወይም ተደጋጋሚ ቅሬታ፣ ማጭበርበር፣ መለያ ማጋራት፣ የክፍያ አላግባብ አጠቃቀም፣ ሕገወጥ ድርጊት፣ የውል ጥሰት፣ የመንግሥት መመሪያ ወይም የመድረክ ደህንነት ሲያስፈልግ YegnaTaxi ማመልከቻን ሊቃወም፣ ጥያቄን ሊገድብ፣ ከመስመር ውጭ ሊያደርግ፣ ሊያግድ ወይም መዳረሻን ሊዘጋ ይችላል።",
          "መጠበቅ ስጋት ሲፈጥር አስቸኳይ ገደብ ሊደረግ ይችላል። ተገቢና ሕጋዊ ሲሆን ምክንያት ወይም የግምገማ መንገድ እንሰጣለን። ተሳትፎን ማቆም ይችላሉ፤ ያልተጠናቀቀ ጉዞ፣ ገንዘብ፣ ምርመራና መዝገብ ግን መፈታት ወይም በሕግ መቆየት አለበት።",
        ],
      },
      {
        id: "privacy",
        heading: "11. ግላዊነትና ምስጢራዊነት",
        paragraphs: [
          "የYegna Driver የግላዊነት ፖሊሲ የማንነት ሰነድንና የመስመር ላይ መገኛን ጨምሮ ዳታዎን እንዴት እንደምንይዝ ያብራራል። የተሳፋሪ፣ ተቀባይ፣ መንገድ፣ ሠራተኛና የመድረክ መረጃን ይጠብቁ፤ ጉዞን ለመፈጸም፣ ሕግን ለማክበር ወይም እውነተኛ የደህንነት ጉዳይን ለመፍታት ብቻ ይጠቀሙ።",
          "ዳታን አይቅዱ፣ አይሽጡ፣ አያሳትሙ፣ ለገበያ አይጠቀሙ ወይም ተሳፋሪን ለሌላ ዓላማ አያነጋግሩ። ዳታው ካላስፈለገ በሕጋዊ ማስረጃ ጥበቃ መሠረት ይመልሱት ወይም በደህና ያጥፉት።",
        ],
      },
      {
        id: "intellectual-property",
        heading: "12. መተግበሪያና የአእምሮ ንብረት",
        paragraphs: [
          "YegnaTaxi ለተፈቀደ አሽከርካሪ መተግበሪያውን ለተፈቀደ የDriver ባህሪ ብቻ እንዲጠቀም የተገደበ፣ ሊነሳ የሚችል፣ ለሌላ የማይተላለፍ ፈቃድ ይሰጣል። የመተግበሪያ፣ ብራንድ፣ ንድፍ፣ ሶፍትዌርና ይዘት መብት የYegnaTaxi ወይም የፈቃድ ሰጪዎቹ ነው።",
          "ሕግ በግልጽ ካልፈቀደ በስተቀር መቅዳት፣ እንደገና መሸጥ፣ ኮድ መፍታት፣ ዳታ መፋቅ፣ አውቶማቲክ ማድረግ፣ ማስተጓጎል፣ የውሸት ጥያቄ መላክ፣ ደህንነትን ማለፍ ወይም ተወዳዳሪ ዳታ ጎታ መፍጠር አይፈቀድም።",
        ],
      },
      {
        id: "responsibility",
        heading: "13. ኃላፊነትና የአገልግሎት ገደብ",
        paragraphs: [
          "ተሽከርካሪን በሕግ ማሽከርከር፣ የተቀበሉትን ጉዞ ማከናወን፣ ጥቅልን በደህና መያዝ እና በማጭበርበር፣ ሆን ብሎ በሚደረግ ጥፋት፣ በቸልተኝነት ወይም በውል ጥሰት ለሚፈጠር ጉዳት ኃላፊነትዎ ይቀጥላል። YegnaTaxi ለራሱ ድርጊት በኢትዮጵያ ሕግ በሚወሰነው መጠን ኃላፊ ነው። ሕግ እንዲወገድ የማይፈቅደው መብት ወይም ኃላፊነት አይወገድም።",
          "በሕግ እስከተፈቀደው ድረስ YegnaTaxi የማያቋርጥ መዳረሻ፣ የተወሰነ የጉዞ ብዛት፣ ዝቅተኛ ገቢ፣ የተወሰነ ተሳፋሪ፣ የመንገድ ትክክለኛነት ወይም የማይቋረጥ ኔትወርክ ዋስትና አይሰጥም፤ ለተዘዋዋሪ ወይም ሊገመት ለማይችል ጉዳት ወይም ከቁጥጥር ውጭ ላለ ክስተት ኃላፊ አይሆንም።",
        ],
      },
      {
        id: "law-disputes",
        heading: "14. የኢትዮጵያ ሕግና ክርክር",
        paragraphs: [
          "እነዚህ ውሎች በኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ ሕጎች ይመራሉ። በመጀመሪያ የDriver ድጋፍን ያነጋግሩና ጉዳዩን ለመፍታት ምክንያታዊ ጊዜ ይስጡን። ያልተፈታ ጉዳይ በኢትዮጵያ ሕግ ላለው ተቆጣጣሪ፣ ፍርድ ቤት ወይም የክርክር ሂደት ሊቀርብ ይችላል። ግዴታ በሆነ ሕግ ወይም በሕጋዊ ተለየ ውል ተቃራኒ ካልሆነ በአዲስ አበባ ሥልጣን ባለው ፍርድ ቤት ሊቀርብ ይችላል።",
        ],
      },
      {
        id: "changes-contact",
        heading: "15. ለውጦችና መገናኛ",
        paragraphs: [
          "ለአገልግሎት፣ ደህንነት፣ ሥራ ወይም ሕግ ለውጥ ውሎቹን ልናሻሽል እንችላለን። አዲሱን ቀን እናወጣለን፤ ከፍተኛ ለውጥ ሲኖር ተጨማሪ ማሳወቂያ እንሰጣለን። ከተፈጻሚነት ቀን በኋላ መጠቀምዎ ማሻሻያውን እንደተቀበሉ ያሳያል፤ ካልተስማሙ ከመስመር ውጭ ሆነው የDriver ባህሪዎችን መጠቀም ያቁሙ።",
          "ጥያቄን በYegna Driver ድጋፍ ያቅርቡ ወይም ለAD Technologies and Trading (YegnaTaxi)፣ አዲስ አበባ፣ ቂርቆስ ክፍለ ከተማ፣ ወረዳ 08፣ የቤት ቁጥር 3-310፣ ኢትዮጵያ ይጻፉ።",
        ],
      },
    ],
  },
];
